module.exports = __webpack_public_path__ + "img/kp.07ebeb5c.svg";